import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	selectedPlan: null,
	billingType: 'yearly',
};

const subscriptionSlice = createSlice({
	name: 'subscription',
	initialState,

	reducers: {
		setPlan: (state, action) => {
			state.selectedPlan = action.payload;
		},

		setBillingType: (state, action) => {
			state.billingType = action.payload;
		},

		clearSubscription: (state) => {
			state.selectedPlan = null;
			state.billingType = 'yearly';
		},
	},
});

export const { setPlan, setBillingType, clearSubscription } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
